export const messages = {
  en: {
    message: {
      democrats: "Democrats",
      democratic: "Democratic",
      republican: "Republican",
      republicans: "Republicans",
      lastUpdated: "Last updated",
      candidate: "Candidate",
      candidates: "Candidates",
      votes: "Votes",
      percent: "Percent",
      percentAbbreviation: "Pct.",
      candidateAdvancingToGeneral: "Candidate advancing to general election",
      candidateAdvancingToRunoff: "Candidate advancing to runoff",
      showMoreCandidates: "+ Show All Candidates",
      showFewerCandidates: "- Fewer Candidates",
      incumbent: "Incumbent",
      votesIn: "est. reporting",
      estimated: "Estimated",
      votesCounted: "Votes counted",
      in: "in",
      townshipResults: "Township Results",
      countyResults: "County Results",
      loadingResults: "Loading Results",
      changeRace: "Change Race",
      district: "District",
      forMajority: "for majority",
      tapAState: "Tap a state below for detailed results",
      leading: "Leading",
      won: "Won",
      noResults: "No Results",
      backToNationwideMap: "Back to Nationwide Map",
      nationwide: "Nationwide",
      seats: "seats",
      seatCount: "Seat Count",
      runoff: "Runoff",
      tiedSenate:
        "In case of 50-50 Senate, Democrats will maintain control with VP Kamala Harris' tie breaking vote.",
      president: "President",
      usSenate: "US Senate",
      usHouse: "US House",
      governor: "Governor",
      secretaryOfState: "Secretary of State",
      attorneyGeneral: "Attorney General",
      precinctsReporting: "Precincts reporting",
      atLarge: "At-Large",
      stateSenate: "State Senate",
      stateHouse: "State House",
      primary: "Primary",
      party: "Party",
      national: "National",
      total: "Total",
    },
  },
  es: {
    message: {
      democrats: "Demócratas",
      democratic: "Democrático",
      republican: "Republicano",
      republicans: "Republicanos",
      lastUpdated: "Última actualización",
      candidate: "Candidato",
      candidates: "Candidatos",
      votes: "Votos",
      percent: "Por Ciento",
      percentAbbreviation: "%",
      candidateAdvancingToGeneral: "Candidato que avanza a las elecciones generales",
      candidateAdvancingToRunoff: "Candidato avanzando a la segunda vuelta",
      showMoreCandidates: "+ Más Candidatos",
      showFewerCandidates: "- Menos Candidatos",
      incumbent: "Titular",
      votesIn: "informes est.",
      estimated: "Estimado",
      votesCounted: "Votos contados",
      in: "en",
      townshipResults: "Resultados del Municipio",
      countyResults: "Resultados del condado",
      loadingResults: "Cargando Resultados",
      changeRace: "Cambiar carrera",
      district: "Distrito",
      forMajority: "para la mayoría",
      tapAState: "Toque un estado a continuación para obtener resultados detallados",
      leading: "Destacado",
      won: "Ganó",
      noResults: "No hay resultados",
      backToNationwideMap: "Volver al mapa nacional",
      nationwide: "A escala nacional",
      seats: "escaños",
      seatCount: "Recuento de escaños",
      runoff: "Segunda vuelta",
      tiedSenate:
        "En el caso de un Senado 50-50, los demócratas mantendrán el control con el voto de desempate de la vicepresidenta Kamala Harris.",
      president: "Presidente",
      usSenate: "Senado de los Estados Unidos",
      usHouse: "Cámara de los Estado Unidos",
      governor: "Gobernador",
      secretaryOfState: "Secretario de estado",
      attorneyGeneral: "Procurador General",
      precinctsReporting: "Informe de los distritos electorales",
      atLarge: "en General",
      stateSenate: "Senado Estatal",
      stateHouse: "Cámara del Estado",
      primary: "Primario",
      party: "Partido",
      national: "Nacional",
      total: "Total",
    },
  },
};
